import React, { useEffect, useState } from 'react';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { CateringPackageOrderFlow } from '../catering-order-flow/CateringPackageOrderFlow';

export const CateringPackageSlideCmp = ({
  cateringPackage,
  booking,
  profile
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
    analytics.track('catering_menu_viewed', {
      booking_id: booking?._id,
      sso_id: profile?.data?.SSOid,
      activity_tag: booking?.tags?.activity,
      catering_package_id: cateringPackage?.id
    });
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const packageFromUrl = searchParams.get('package');
    if (packageFromUrl === cateringPackage.id) {
      openModal();
    }
  }, []);

  return (
    <>
      <div className="catering-package-slide" onClick={() => openModal()}>
        {cateringPackage.badge && (
          <div className="catering-package-badge tw-body-1-m">
            {cateringPackage.badge}
          </div>
        )}
        <div>
          <img src={cateringPackage.coverImage} alt={cateringPackage.name} />
        </div>
        <div className="margin-lg-top">
          <p className="tw-body-2-m no-margin" style={{ marginBottom: '2px' }}>
            {cateringPackage.name}
          </p>

          <p className="tw-body-1 no-margin" style={{ marginBottom: '6px' }}>
            {cateringPackage.subtext}
          </p>

          {cateringPackage.price?.value > 0 && (
            <p className="tw-body-1 no-margin text-gray-600">
              {cateringPackage.price.starts_at && 'Starts at '}
              <FormattedNumber
                value={cateringPackage.price.value}
                currency="USD"
                style="currency"
                minimumFractionDigits={
                  Number.isInteger(cateringPackage.price.value) ? 0 : 2
                }
                maximumFractionDigits={2}
              />{' '}
              per person
            </p>
          )}
        </div>
      </div>
      {modalOpen && (
        <CateringPackageOrderFlow
          cateringPackage={cateringPackage}
          closeModal={() => setModalOpen(false)}
          booking={booking}
        />
      )}
    </>
  );
};

export const CateringPackageSlide = connect(({ profile }) => ({ profile }))(
  CateringPackageSlideCmp
);
